<template>
  <div class="ws-card" @click="$_onClick($event)">
    <div
      v-if="hasTopBar"
      class="ws-card_top-bar-declaration"
    />
    <div>
      <div
        v-if="bannerUrl"
        class="ws-card__banner"
        :style="{backgroundImage: 'url(' + bannerUrl + ')' }"
      >
      </div>
      <div class="card-container">
        <router-link
          v-if="to"
          :to="to"
        >
          <slot />
        </router-link>
        <div v-else>
          <slot />
        </div>
      </div>
    </div>
    <slot name="footer"/>
  </div>
</template>
<script>
export default {
  name: "WsCard001",
  props: {
    to: {
      type: String,
      default: null,
    },
    hasTopBar: {
      type: Boolean,
    },
    bannerUrl: {
      type: String,
      default: null,
    }
  },
  methods: {
    $_onClick($event) {
      if (this.to && $event.target.className === 'ws-card') {
        this.$router.push(this.to);
      } else {
        this.$emit('click',$event);
      }
    }
  }
};
</script>